import {
  XeroConnectionDisconnectResult,
  XeroConnectionSafe,
  XeroConnectionStateResult,
  XeroHubConnectStartResult,
  XeroSelectTenantInput,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function getXeroConnection(): Promise<XeroConnectionStateResult> {
  return httpClient.get<XeroConnectionStateResult>('/protected/xero-connection/');
}

export async function startXeroHubConnect(): Promise<XeroHubConnectStartResult> {
  return httpClient.post<XeroHubConnectStartResult>('/protected/xero-connection/start');
}

export async function selectXeroTenant(input: XeroSelectTenantInput): Promise<XeroConnectionSafe> {
  return httpClient.post<XeroConnectionSafe, XeroSelectTenantInput>(
    '/protected/xero-connection/select-tenant',
    input
  );
}

export async function disconnectXeroConnection(): Promise<XeroConnectionDisconnectResult> {
  return httpClient.delete<XeroConnectionDisconnectResult>('/protected/xero-connection/');
}
